module.exports = __webpack_public_path__ + "media/images/missing-image-fr-091d51dfc4d98ade06b108e88a32057e.png";